import requestService from "./requestService"

export default {
    async getAllNumbers() {
        return await requestService.get('/dashboard/graphics')
    },
}